






























































import { Component, Vue } from 'vue-property-decorator'
import axios from '@/server-axios'

@Component
export default class Register extends Vue {
    errors: string[] = []
    firstName: string = ''
    lastName: string = ''
    password: string = ''
    confirmPassword: string = ''
    email: string = ''

    async registerForAccount() {
        console.log('register')
        this.errors = []
        if (this.password !== this.confirmPassword) {
            this.errors.push('Your passwords do not match')
            return
        }

        try {
            const user = {
                firstName: this.firstName,
                lastName: this.lastName,
                password: this.password,
                username: this.email,
            }

            const { status } = await axios.post('users/register', user)

            console.log(status)

            this.$router.push('/login')

        } catch (e) {
            if (e.request.status === 409) {
                this.errors.push('That email is already in use')
            }
        }

    }
}
